import { connect } from 'react-redux'
import { logoutUser, loadUserInfo } from '../../auth/actions';
import { bindActionCreators } from 'redux';

import Dashboard from '../components/Dashboard'

const mapDispatchToProps = dispatch => {
  const actions = {
    logoutUser,
    loadUserInfo
  }
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}
  
function mapStateToProps (state) {
  const { auth } = state;
  return { ...auth };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Dashboard)